/* eslint-disable sonarjs/no-duplicate-string */
import makeStyles from "@material-ui/core/styles/makeStyles";

import { userInfoAvatarSize, cardLookStyle } from "../globalStyles";

const useStyles = makeStyles((theme) => {
  const padding = {
    padding: theme.spacing(2, 3),
  };

  const marginRight = {
    marginRight: theme.spacing(4),
  };

  const bigMarginRight = {
    marginRight: theme.spacing(8),
  };

  const smallMarginRight = {
    marginRight: theme.spacing(1),
  };

  return {
    userSectionWrap: {
      ...cardLookStyle,
      ...padding,
      minHeight: `calc(${theme.spacing(28)}px + 2.2em)`,
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "space-between",
      backgroundColor: "white",
      gap: 24,
    },
    historyWrap: {
      ...cardLookStyle,
      ...padding,
      backgroundColor: "white",
    },
    userInfoSection: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      flexWrap: "wrap",
      ...padding,
    },
    userDataInfoRow: {
      display: "flex",
      alignItems: "center",
    },
    dataRowLabel: {
      marginRight: theme.spacing(4),
      color: theme.palette.text.secondary,
    },
    dataRowValue: {
      color: theme.palette.text.primary,
    },
    editableDataRowLabel: {
      marginRight: theme.spacing(1),
      color: theme.palette.text.secondary,
    },
    itemsSectionWrap: {
      ...cardLookStyle,
    },
    avatarPanel: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      minWidth: 200,
      [theme.breakpoints.up("sm")]: {
        flexDirection: "row",
        alignItems: "center",
      },
    },
    avatar: {
      display: "grid",
      placeItems: "center",
      width: userInfoAvatarSize * 0.7,
      height: userInfoAvatarSize * 0.7,
      [theme.breakpoints.up("sm")]: {
        width: userInfoAvatarSize,
        height: userInfoAvatarSize,
      },
    },
    avatarWrap: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    avatarText: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      marginTop: theme.spacing(1),
      marginLeft: 0,
      [theme.breakpoints.up("sm")]: {
        alignItems: "flex-start",
        marginTop: 0,
        marginLeft: theme.spacing(2),
      },
    },
    avatarName: {
      fontSize: 32,
      fontWeight: 600,
    },
    avatarEmail: {
      fontSize: 18,
      color: "grey",
    },
    leftPanelWrapper: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      gap: 14,
      [theme.breakpoints.up("sm")]: {
        width: "auto",
      },
    },
    leftElement: {
      ...marginRight,
    },
    smallMarginRight: {
      ...smallMarginRight,
    },
    bigMarginRight: {
      ...bigMarginRight,
    },
    editableInput: {
      width: 180,
    },
    actionsPanelWrap: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-start",
      width: "100%",
      minWidth: 320,
      [theme.breakpoints.up("sm")]: {
        justifyContent: "flex-end",
        alignItems: "flex-end",
        width: "auto",
      },
    },
    actionsPanel: {
      display: "flex",
      justifyContent: "flex-start",
      marginTop: 5,
      alignItems: "center",
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        justifyContent: "flex-end",
      },
    },
    resize: {
      fontSize: 14,
    },
  };
});

export default useStyles;
